<template>
  <v-layout class="grey lighten-4" column>
    <div class="noto bold pa-3 d-md-flex align-center" width="100%">
      <v-btn
        small
        text
        rounded
        fab
        color="success"
        :to="{ name: 'Inventory', params: { area } }">
        <v-icon>
          mdi-arrow-left
        </v-icon>
      </v-btn>
      <div class="title primary--text">{{ section }}</div>
      <v-spacer />
      <div class="d-flex justify-end align-center">
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Busca productos por nombre"
          solo
          hide-details
          rounded
          flat
          dense/>
        <div class="px-3">
          <v-tooltip left>
            <template
              v-slot:activator="{ on }">
              <v-btn
                v-on="on"
                :href="exportRoute"
                target="_blank"
                dark
                fab
                x-small
                depressed
                color="primary">
                <v-icon color="white">mdi-application-export</v-icon>
              </v-btn>
            </template>
            <span>Exportar inventario a CSV</span>
          </v-tooltip>
        </div>
      </div>
    </div>

    <div class="px-3">
      <v-card class="px-3">
        <v-row>
          <v-col
            class="d-flex justify-space-between">
            <div class="subtitle-2">
              Valor del inventario físico:
            </div>
            <div class="primary--text">
              {{ calculateTotal('amountQuantityAvailable') | toFixNumber(2) | prefix('$') | numberWithComma }}
            </div>
          </v-col>
          <v-col
            class="d-flex justify-space-between">
            <div class="subtitle-2">
              Valor del inventario teórico:
            </div>
            <div class="primary--text">
              {{ calculateTotal('amountQuantityCalculated') | toFixNumber(2) | prefix('$') | numberWithComma }}
            </div>
          </v-col>
          <v-col
            class="d-flex justify-space-between">
            <div class="subtitle-2">
              Valor de la diferencia:
            </div>
            <div class="primary--text">
              {{ calculateTotal('amountDifference') | toFixNumber(2) | prefix('$') | numberWithComma }}
            </div>
          </v-col>
        </v-row>
      </v-card>
    </div>

    <v-flex xs12>
      <v-data-table
        :loading-text="table.title"
        :server-items-length="table.total"
        :loading="table.loading"
        :headers="table.headers"
        :items="table.data"
        :options="table.options"
        :sort-by="sortAttrName"
        @update:options="updateTable"
        @update:sort-by="sortByTable"
        @update:sort-desc="sortDescTable"
        :footer-props="table.footer"
        class="elevation-1 d-print fixed-header">
        <template
          v-slot:top>
          <div class="px-3">
            <v-row>
              <v-col cols="1">
                <span class="subtitle-2 grey--text">
                  Filtrar por:
                </span>
              </v-col>
              <v-col cols="3">
                <v-menu
                  ref="datePicker"
                  v-model="datePicker"
                  :close-on-content-click="false"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      v-model="range"
                      label="Selecciona una semana"
                      prepend-icon="mdi-calendar"
                      readonly
                      hide-details
                      dense
                      v-on="on"
                    ></v-text-field>
                  </template>
                    <!-- v-model="dates" -->
                  <v-date-picker
                    :value="dates"
                    :range="true"
                    first-day-of-week="1"
                    no-title
                    @click:date="setDates"
                  >
                    <v-btn text color="primary" @click="resetDate">Borrar</v-btn>
                    <v-spacer/>
                    <v-btn text color="grey" @click="datePicker = false">Cancel</v-btn>
                    <v-btn :disabled="dates.length < 2" color="primary" @click="filterByDate">OK</v-btn>
                  </v-date-picker>
                </v-menu>
              </v-col>
              <v-col cols="2">
                <v-select
                  v-model="category"
                  :items="categories"
                  item-text="name"
                  item-value="id"
                  label="Departamento"
                  hide-details
                  dense
                  return-object
                  @change="onChangeCategory"
                />
              </v-col>
            </v-row>
          </div>
        </template>
        <template v-slot:item.name="{ item }">
          <div style="max-width:200px">
            <div>
              {{ item.name }}
            </div>
            <div v-if="item.description" class="caption grey--text text-uppercase">
              {{ item.description }}
            </div>
            <div
              v-if="item.provider"
              class="caption grey--text">
              {{ item.provider }}
            </div>
            <div
              v-else
              class="caption grey--text">
              Subreceta
            </div>
          </div>
        </template>
        <template v-slot:item.unitPrice="{ item }">
          <div class="text-right">
            <div>
              {{ item.unitPrice | toFixNumber(2) | prefix('$') | numberWithComma }}
            </div>
            <div class="caption grey--text">
              1/{{ item.unitCode }}
            </div>
          </div>
        </template>
        <template v-slot:item.previousWeekQuantity="{ item }">
          <div
            class="text-right">
            {{ item.quantityArchived | toFixNumber(2) | numberWithComma }}
            <span class="caption grey--text">
              {{ item.unitCode }}
            </span>
          </div>
        </template>
        <template v-slot:item.weeklyPurchase="{ item }">
          <div
            class="text-right">
            {{ item.weeklyPurchase | toFixNumber(2) | numberWithComma }}
            <span class="caption grey--text">
              {{ item.unitCode }}
            </span>
          </div>
        </template>
        <template v-slot:item.stock="{ item }">
          <div class="text-right">
            <span>
              {{ item.stock | toFixNumber(0) | numberWithComma }}
            </span>
            <span class="caption grey--text">
              {{ item.unitCode }}
            </span>
          </div>
        </template>
        <template
          v-slot:item.consumption="{ item }"
          v-if="$is() === 'manager'">
          <div class="text-right" style="max-width:250px">
            <span>
              {{ item.consumption | toFixNumber(2) | numberWithComma }}
            </span>
            <span class="caption">
              {{ item.unitCode }}
            </span>
          </div>
        </template>
        <template
          v-slot:item.quantityAvailable="{ item }"
          v-if="$is() === 'stockmanager' || $is() === 'manager'">
          <div class="text-right" style="max-width:250px">
            <span>
              {{ item.quantityAvailable | toFixNumber(2) | numberWithComma }}
            </span>
            <span class="caption">
              {{ item.unitCode }}
            </span>
          </div>
          <div
            v-if="$is() === 'manager'"
            class="text-right caption grey--text">
            {{ item.amountQuantityAvailable || 0 | toFixNumber(2) | prefix('$') | numberWithComma }}
          </div>
        </template>
        <template v-slot:item.theoricalInventory="{ item }">
          <div class="text-right">
            <span>
              {{ item.theoricalInventory | toFixNumber(2) | numberWithComma }}
            </span>
            <span class="caption">
              {{ item.unitCode }}
            </span>
          </div>
          <div
            v-if="$is() === 'manager'"
            class="text-right caption grey--text">
            {{ item.amountQuantityCalculated || 0 | toFixNumber(2) | prefix('$') | numberWithComma }}
          </div>
        </template>
        <template v-slot:item.difference="{ item }">
          <div class="text-right">
            <span>
              {{ item.difference | toFixNumber(2) | numberWithComma }}
            </span>
            <span class="caption">
              {{ item.unitCode }}
            </span>
          </div>
          <div
            v-if="$is() === 'manager'"
            class="text-right caption grey--text">
            {{ item.amountDifference || 0 | toFixNumber(2) | prefix('$') | numberWithComma }}
          </div>
        </template>
      </v-data-table>
    </v-flex>

    <v-overlay :value="overlay" z-index="99999">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </v-layout>
</template>

<script>
import _ from 'lodash'
import moment from 'moment'

export default {
  name: 'Inventory',
  data () {
    return {
      isValid: false,
      datePicker: false,
      dates: [],
      cleanDialog: false,
      overlay: false,
      section: this.$i18n.t('inventory.listTitle'),
      sortAttrName: 'name',
      attrNamesSorteable: ['name', 'choice.provider.name', 'area.name', 'difference'],
      loadedData: null,
      table: {
        title: this.$i18n.t('inventory.loading'),
        loading: true,
        headers: [
          { text: 'Nombre', value: 'name' },
          { text: 'Departamento', value: 'category' },
          { text: 'Precio unitario', value: 'unitPrice', sortable: false },
          { text: 'Stock semanal', value: 'stock', sortable: false },
          { text: 'Inventario físico semana anterior', value: 'previousWeekQuantity', sortable: false },
          { text: 'Venta semanal', value: 'weeklyPurchase', sortable: false },
          { text: 'Consumo', value: 'consumption', sortable: false },
          { text: 'Inventario físico', value: 'physicalInventory', sortable: false },
          { text: 'Inventario teórico', value: 'theoricalInventory', sortable: false },
          { text: 'Diferencia', value: 'difference', sortable: false }
        ],
        data: [],
        total: 0,
        options: {
          itemsPerPage: 1000,
          page: 1
        },
        footer: {
          'items-per-page-options': [5, 50, 100, 200]
        }
      },
      info: {
        activated: false,
        loading: false,
        item: null,
        data: {
          recipes: null,
          movements: null
        }
      },
      categories: [],
      category: null,
      search: '',
      errors: [],
      rules: {
        numberValid: [
          v => (v !== '' && !isNaN(v * 1)) || this.$t('validations.numberValid')
        ]
      },
      favorites: 0
    }
  },
  computed: {
    area () {
      return this.$store.state.area.id
    },
    range () {
      return this.dates.length < 2 ? '' : `${this.dates[0]} / ${this.dates[1]}`
    },
    exportRoute () {
      const date = moment(this.dates[1]).add(1, 'd').format('YYYY-MM-DD') || ''
      return `${process.env.VUE_APP_API_URL}/v1/inventory/export?restaurant=${this.$store.state.currentRestaurant.data._id}&date=${date}`
    }
  },
  watch: {
    'search': async function (val) {
      const params = {
        limit: this.table.options.itemsPerPage,
        area: this.$store.state.area.id,
        skip: (this.table.options.itemsPerPage * (this.table.page - 1)),
        sort: 'name'
      }
      if (val.length >= 3) {
        try {
          params.name = new RegExp(val, 'i')
          let content = this.loadedData
          if (this.category) {
            params['product.category'] = this.category
            content = content.filter(x => {
              if (x.product && x.product.category) {
                return x.product.category.uuid === params['product.category']
              }
              return false
            })
          }
          content = content.filter(x => params.name.test(x.name))
          this.table.data = content
          this.table.total = content.length
        } catch (error) {
          this.$toasted.show(error.message, { duration: 3000 })
        }
      } else {
        this.filterByCategory(this.category)
      }
    }
  },
  async mounted () {
    await this.getCategories()
    if (this.$store.state.area) {
      await this.load({
        limit: -1,
        skip: 0,
        sort: 'name',
        area: this.$store.state.area.id
      })
    }
  },
  methods: {
    setDates (date) {
      this.dates = []
      const selectedDate = moment(date)
      const startDate = selectedDate.startOf('week').format('YYYY-MM-DD')
      const endDate = selectedDate.endOf('week').format('YYYY-MM-DD')
      this.dates.push(...[startDate, endDate])
    },
    async resetDate () {
      this.dates = []
      await this.load()
      this.datePicker = false
    },
    async filterByDate () {
      this.dates.sort((a, b) => {
        if (a < b) return -1
        if (a > b) return 1
        return 0
      })
      const dates = {}
      if (this.dates.length) {
        dates['createdAt>'] = this.dates[0]
        dates['createdAt<'] = `${this.dates[1]}T23:59:59`
      }
      const params = {
        ...dates
      }
      params.area = this.area
      await this.load(params)
      this.datePicker = false
    },
    updateTable: async function (data) {
      const { sortBy, sortDesc } = data
      const start = data.itemsPerPage * (data.page - 1)
      const end = data.itemsPerPage * data.page
      const sortParam = (sortDesc > 0 ? '' : '-') + sortBy
      this.table.data = _.sortBy(this.loadedData, sortParam).slice(start, end)
    },
    async load (params = null) {
      params = params || {}
      this.table.loading = true
      try {
        const response = await this.$api.get('/v1/inventory', params)

        const items = response ? response.items : []
        this.loadedData = items.map(item => {
          const amountQuantityCalculated = item.theoricalInventory * item.unitPrice
          const amountQuantityAvailable = item.physicalInventory * item.unitPrice
          const amountDifference = item.difference * item.unitPrice

          return Object.assign(
            item,
            {
              amountQuantityCalculated,
              amountQuantityAvailable,
              amountDifference
            }
          )
        })
        this.table.data = this.loadedData

        await this.updateTable({
          sortBy: 'name',
          sortDesc: 1,
          itemsPerPage: this.table.options.itemsPerPage,
          page: this.table.options.page
        })

        this.table.total = response ? response.items.length : 0
      } catch (error) {
        this.$toasted.show(error.message, { duration: 3000 })
      }
      this.table.loading = false
    },
    async getCategories () {
      const { data } = await this.$api.get(`/v1/categories`, { sort: 'name' })
      data.unshift({ id: null, name: 'Todas' })
      this.categories = data
    },
    onChangeCategory (category) {
      this.search = ''
      this.filterByCategory(category)
    },
    filterByCategory (category) {
      this.category = category
      const params = {
        sort: 'name',
        area: this.$store.state.area.id
      }
      this.table.loading = true
      if (category && category.name !== 'Todas') {
        params['category'] = new RegExp(category.name, 'gi')
        const content = this.loadedData.filter(x => {
          if (x.category) {
            return params['category'].test(x.category)
          }
          return false
        })
        this.table.data = content
        this.table.total = content.length
      } else {
        this.table.data = this.loadedData
        this.table.total = this.loadedData.length
      }
      this.table.loading = false
    },

    async sortDescTable (data) {
      if (!data) return
      this.loadedData = this.loadedData.reverse()
      await this.updateTable({
        sortBy: this.sortAttrName,
        sortDesc: -1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page
      })
    },
    async sortByTable (data) {
      if (!data && !this.attrNamesSorteable.includes(data)) return
      const floatColumns = [ 'difference' ]
      this.loadedData = this.loadedData.sort((a, b) => {
        a = _.get(a, data)
        b = _.get(b, data)
        if (floatColumns.includes(data)) {
          a = parseFloat(a)
          b = parseFloat(b)
        }
        if (a > b) return 1
        if (a < b) return -1
        return 0
      })
      this.sortAttrName = data
      await this.updateTable({
        sortBy: data,
        sortDesc: 1,
        itemsPerPage: this.table.options.itemsPerPage,
        page: this.table.options.page
      })
    },
    calculateTotal (attr) {
      const total = this.table.data.reduce((acc, val) => {
        return acc + (val[attr] || 0)
      }, 0)
      return total
    }
  }
}
</script>

<style lang="scss">
.action-black {
  color: black !important;
}
.z-index--100 {
  z-index: 100 !important;
}
</style>
